import { referenceUrl } from "./paths";
import { fetchOptionalJson } from "./utils";

// Module-level cache of parsed reference JSON, populated by App's
// mount-time prefetch and consumed synchronously by useReferenceJson's
// lazy initial state. Lets ScorePanel render with populated regions on
// its very first render after speedrun entry — no empty-state frame.

const cache = new Map();
const inflight = new Map();

export function preloadReference(marcId) {
  if (!marcId || cache.has(marcId) || inflight.has(marcId)) return;
  const p = fetchOptionalJson(referenceUrl(marcId)).then((data) => {
    if (data) cache.set(marcId, data);
    inflight.delete(marcId);
    return data;
  });
  inflight.set(marcId, p);
}

export function getCachedReference(marcId) {
  if (!marcId) return null;
  return cache.get(marcId) ?? null;
}
